import React, { Component } from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

import {Config, Time} from '../../util';
import {selectDate} from '../../actions';

import CardListContainer from './CardListContainer';

import Timetable from '../../components/timetable/Timetable';
import Timeline from '../../components/timeline';
import {ScheduleErr} from '../../components/errorpage';

// let total; // 전역변수로 epg정보 받을때
let TIMER;
class Schedule extends Component {
  constructor(props){
    super(props);
    this.state={
      currentTime: '',
      timeBarPosition: '0',
      showLineBar: false,
      total: []
    };
  }
  componentWillMount(){
    
  }
  componentDidMount(){
    if(this.props.selectedDate === Time.getToday()){
      this.timerController();
    }
  }
  componentWillUnmount(){
    clearInterval(TIMER);
    TIMER = undefined;
  }
  componentWillReceiveProps (nextProps, nextState) {
    if(this.props.selectedDate !== nextProps.selectedDate){
      this.timerController(nextProps.selectedDate);
    }
  }
  timerController(selectedDate = Time.getToday()){
    const runTimer = Time.getToday() === selectedDate;   
    if(TIMER) clearInterval(TIMER);
    if(runTimer){
      this.getCurrentTimeBarPosition();
      TIMER = setInterval(() => {
        this.getCurrentTimeBarPosition();
      }, 1000 * 10); // 10초마다 check
    }
    this.setState({
      showLineBar: runTimer
    })
  }

  getCurrentTimeBarPosition(){
    const now = moment();
    const realTime = now.format('HH:mm');
    
    const hour = parseInt(realTime.split(':')[0], 10);
    const minute = parseInt(realTime.split(':')[1], 10);

    const timeBarPosition = hour * (3 *60 +4) + (minute/60) * (3*60 + 4);// + 40;
    this.setState({
      currentTime : realTime,
      timeBarPosition,
    })
  }
  renderChList(){
    const {
      total,
      activeChannelListIndex
    } = this.props;
    return total.map((cardList, idx) => {
      const channelIndex = parseInt(idx / Config.channelCnt, 10);
      
      return (
        
        <CardListContainer cardList={cardList} channelIndex={channelIndex} key={idx} />
      )
    });
  }
  renderTimeline(){
    const {
      currentTime,
      timeBarPosition,
      showLineBar
    } = this.state;
    if(showLineBar){
      return (<Timeline 
        currentTime={currentTime}
        timeBarPosition={timeBarPosition}
        key='ui-timeline'
      />);
    } else {
      return null;
    }
  }
  renderSchedule(){
    const component = [this.renderTimeline()];
    component.push(
      <div className='list schedule' key="ui-schedule">
        {this.renderChList()}
      </div>
    );
    component.push(
      <Timetable key="ui-timetable"/>
    )
    return component;
  }

  render() {
    const {
      currentTime,
      timeBarPosition,
      showLineBar,
     
    } = this.state;
    const {
      total,
      showError
    } = this.props;

  
    return (
      <div className='schedule-wrapper' >
        {showError ? <ScheduleErr /> : this.renderSchedule()}
      </div>

    )
  }
}

const mapDispatcherToProps = dispatch => {
  return {
    selectDate: (selectedDate) => dispatch(selectDate(selectedDate)),
  }
};


const mapStateToProps = (state) => {
  return {
    selectedDate: state.selectedDate,
    selectedMenu: state.selectedMenu,
    activeChannelListIndex: state.activeChannelListIndex
  }
};

Schedule = connect(mapStateToProps)(Schedule);

export default Schedule;


// WEBPACK FOOTER //
// ./src/containers/schedule/Schedule.js